import { __awaiter, __rest } from "tslib";
import { TedivoForm, translateTedivoForm, } from "@tedivo/tedivo-form";
import { systemRights } from "@tedivo/tvd-api-models";
import { ListComponentWithActions } from "../../common/ListComponentWithActions";
import Services from "../../../app/services";
import { createTableUserStorageInstance } from "../../../app/preferences/createTableUserStorageInstance";
import { getTranslation } from "../../../app/i18/i18tn";
import goSquared from "../../../app/tracking/goSquared";
import { routeFns } from "../../../app/router/routes";
import router from "../../../app/router";
import securityModule from "../../../app/security/SecurityModule";
import { setAppTitle } from "../../../app/setAppTitle";
import { z } from "zod";
export class TVDAdminParentOrgComponent extends ListComponentWithActions {
    constructor() {
        super();
        this.h1Label = "general:parentOrganizations.title";
        this.goSquaredLabel = "Admin/ParentOrganizations";
        this.topLabel = "general:adminArea";
        this.createLabel = "general:parentOrganizations.adminCreate";
        this.deleteLabel = "general:parentOrganizations.adminDelete";
        this.serviceListCall = Services.parentOrganizations.adminGetAllParentOrgs;
        this.serviceDeleteCall =
            Services.parentOrganizations.adminDeleteParentOrganization;
        this.serviceEditCall =
            Services.parentOrganizations.adminUpdateParentOrganization;
        this.systemRightToEdit = systemRights.ORG.AppAdminDomains;
        const userOptionsStorage = createTableUserStorageInstance("adminParOrgsList");
        this.tableConfig = (data) => createParentOrgsTableConfig(data, this.systemRightToEdit, userOptionsStorage, this.openEditModal, this.openDeleteModal);
        this.createEditForm = createParentOrgEdit;
        setAppTitle(getTranslation("general:parentOrganizations.title"));
        goSquared.trackPage("TEDIVO Admin Pages - Parent Organizations");
    }
}
TVDAdminParentOrgComponent.observedAttributes = [];
customElements.define("tvd-admin-parorgs-component", TVDAdminParentOrgComponent);
function createParentOrgsTableConfig(parentOrganizations, systemRightToEdit, userOptionsStorage, onEditSaveFn, onDeleteFn) {
    const tableConfig = {
        className: "tvd-table tvd-table-smart-table",
        data: parentOrganizations,
        defaultSortBy: "name",
        fields: [
            {
                name: "name",
                label: getTranslation("general:common.name"),
            },
            {
                name: "orgsNamesByIds",
                label: getTranslation("general:organizations.organizations"),
                mapper: createOrgsNode,
            },
            {
                name: "domains",
                label: getTranslation("general:domains.domains"),
                valueFunction: (dta) => dta.domains.join("<br >"),
            },
            {
                name: "modifiedAt",
                label: getTranslation("general:common.modifiedAt"),
                valueFunction: (dta) => {
                    if (dta.modifiedAt) {
                        const d = new Date(dta.modifiedAt);
                        return `${d.toLocaleDateString()}, ${d.toLocaleTimeString()}`;
                    }
                    else {
                        return "";
                    }
                },
                className: "centered",
                fixedWidth: "200px",
            },
        ],
        settings: {
            sortEnabled: true,
            sortVisible: true,
            userOptionsStorage,
            filters: {
                textFieldEnabled: true,
                textFieldFilterFields: ["name"],
                initialTextFieldFilter: userOptionsStorage.retrieveFilterText(),
            },
            labelSortBy: getTranslation("general:common.sortBy"),
            labelSearch: getTranslation("general:common.filterBy"),
        },
        pkFunction: (dta) => dta.parentOrganizationId,
    };
    if (systemRightToEdit &&
        securityModule.userHasPermission(systemRightToEdit)) {
        tableConfig.fields.push({
            name: "domain",
            label: getTranslation("general:common.edit"),
            type: "icon",
            icon: "pencil",
            fixedWidth: "80px",
            notSortable: true,
            onClick: (dta) => {
                onEditSaveFn(dta.parentOrganizationId, dta);
            },
        });
        tableConfig.fields.push({
            name: "domain",
            label: getTranslation("general:common.delete"),
            type: "icon",
            icon: "trash",
            iconVariant: "danger",
            fixedWidth: "80px",
            notSortable: true,
            onClick: (dta) => {
                onDeleteFn === null || onDeleteFn === void 0 ? void 0 : onDeleteFn(dta.parentOrganizationId, dta, "parentOrganizationId");
            },
        });
    }
    return tableConfig;
}
function createParentOrgEdit(submitButton, prevData) {
    var _a;
    const holder = document.createElement("div");
    const nodeDomains = document.createElement("div");
    nodeDomains.innerHTML = `${getTranslation("general:domains.domains")}: <br /><small style="color:var(--sl-color-neutral-600")>${prevData === null || prevData === void 0 ? void 0 : prevData.domains.join("<br />")}</small>`;
    const formFields = [
        {
            name: "name",
            label: "general:common.name",
            type: "textBox",
            initialValue: (prevData === null || prevData === void 0 ? void 0 : prevData.name) || "",
        },
        {
            name: "domains",
            label: "general:domains.domains",
            type: "node",
            node: nodeDomains,
        },
        {
            name: "enabled",
            label: "general:common.enabled",
            type: "checkbox",
            initialValue: (_a = prevData === null || prevData === void 0 ? void 0 : prevData.enabled) !== null && _a !== void 0 ? _a : true,
        },
    ];
    const formValidator = z.object({
        name: z.string().min(1),
        domains: z.string().min(1),
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _b = prevData || {}, { domains: _ } = _b, rest = __rest(_b, ["domains"]);
    const tedivoForm = new TedivoForm({
        fields: formFields,
        onSubmit: () => undefined,
        formValidator: formValidator,
        submitButton: submitButton,
        formProps: { autoFocusOnFirstInput: true },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        hiddenData: Object.assign(Object.assign({}, rest), { domains: (prevData === null || prevData === void 0 ? void 0 : prevData.domains.join("\n")) || "" }),
    });
    translateTedivoForm({
        tedivoForm,
        getTranslation,
    });
    holder.appendChild(tedivoForm.form);
    return {
        node: holder,
        tedivoForm,
        submitFunction: submitPassedToEditDrawer,
    };
    function submitPassedToEditDrawer() {
        return __awaiter(this, void 0, void 0, function* () {
            const validResult = tedivoForm.doSubmitForm();
            const values = tedivoForm.getValues();
            if (validResult.success) {
                yield Services.parentOrganizations.adminUpdateParentOrganization({
                    parentOrganizationId: (prevData === null || prevData === void 0 ? void 0 : prevData.parentOrganizationId) || "",
                    name: values.name,
                    domains: values.domains.split("\n"),
                    enabled: true,
                    orgsIds: (prevData === null || prevData === void 0 ? void 0 : prevData.orgsIds) || [],
                    orgNamesById: (prevData === null || prevData === void 0 ? void 0 : prevData.orgNamesById) || {},
                    createdAt: (prevData === null || prevData === void 0 ? void 0 : prevData.createdAt) || new Date(),
                    modifiedAt: new Date(),
                });
                return true;
            }
            else {
                return false;
            }
        });
    }
}
function createOrgsNode(dta) {
    const div = document.createElement("div");
    Object.keys(dta.orgNamesById || {})
        .map((r) => ({
        orgId: r,
        name: dta.orgNamesById[r],
    }))
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach((r) => {
        const h = document.createElement("div");
        h.className = "parent-orgs-row";
        const span = document.createElement("span");
        span.innerHTML = r.name;
        const editOrgIcon = document.createElement("sl-icon-button");
        editOrgIcon.name = "pencil";
        editOrgIcon.title = getTranslation("general:organizations.adminEdit");
        editOrgIcon.addEventListener("click", () => {
            router.navigate(routeFns.adminOrganizations(), {
                organizationId: r.orgId,
                returnUrl: routeFns.adminParentOrganizations(),
            });
        });
        const editUsersIcon = document.createElement("sl-icon-button");
        editUsersIcon.name = "people";
        editUsersIcon.title = getTranslation("general:users.users");
        editUsersIcon.addEventListener("click", () => {
            router.navigate(routeFns.adminOrganizationUsers(r.orgId), {
                organizationId: r.orgId,
                returnUrl: routeFns.adminParentOrganizations(),
            });
        });
        const editInvoicesIcon = document.createElement("sl-icon-button");
        editInvoicesIcon.name = "receipt-cutoff";
        editInvoicesIcon.title = getTranslation("general:organizations.invoices.title");
        editInvoicesIcon.addEventListener("click", () => {
            router.navigate(routeFns.adminInvoices(r.orgId), {
                organizationId: r.orgId,
                returnUrl: routeFns.adminParentOrganizations(),
            });
        });
        h.appendChild(span);
        h.appendChild(editOrgIcon);
        h.appendChild(editUsersIcon);
        h.appendChild(editInvoicesIcon);
        div.appendChild(h);
    });
    return div;
}
